module.exports = __webpack_public_path__ + "media/Christine_d_Ornano.4429a29c.mp4";